import React, { useState, useEffect, useMemo, useCallback, useRef, memo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { API_BASE_URL } from "../../../Config/Config";
import NotificationTabComponent from "../NotificationTabComponent/NotificationTabComponent";
import "./notificationconfigurationstudentatendence.css";
import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
import SelectedDropdownValues from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown"
import SuccessImg from "../../../Assets/Images/CommanImages/Informative.png";
import WarningIcon from "../../../Assets/Images/CommanImages/Warning.png";
import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
import SingleSelectSearchDropdown from "../../StudentGrouph/SingleSelectSearchDropdown";
import EndPoints from "../../../Api/Endpoints";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import useFieldChangeTracker from "../../../Utils/TrackData/TrackData";
import { HighlightWithinTextarea } from "react-highlight-within-textarea";
import NotificationChannelTabs from "../NotificationChannelTabs/NotificationChannelTabs"


const EventNotificationForm = memo(
  ({ eventConfig, clientBranchNum, accessToken, activeCategory, screenId, onFormDataChange }) => {
    const quillRef = useRef(null);
    const isInitializing = useRef(true);
    const [activeCommModeId, setActiveCommModeId] = useState(null);
    const [formData, setFormData] = useState({});
    const [searchOptions, setSearchOptions] = useState([]);
    const [allSelectedUsersData, setAllSelectedUsersData] = useState([]);
    const [selectedUserGroup, setSelectedUserGroup] = useState("");
    const [isEnabled, setIsEnabled] = useState(false);
    const [sharedUserGroup, setSharedUserGroup] = useState("");

    const STORAGE_KEY = `notification_config_${screenId}_${eventConfig.screen_event_id}`;
    const getStoredData = useCallback(() => {
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored ? JSON.parse(stored) : {};
      } catch {
        return {};
      }
    }, []);

    const saveToStorage = useCallback((data) => {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      } catch (e) {
        console.warn("Failed to save to localStorage:", e);
      }
    }, []);

    const canonicalIdFor = useCallback((item = {}) => {
      if (item.emp_id && String(item.emp_id) !== "-" && String(item.emp_id) !== "null") {
        return String(item.emp_id);
      }
      if (item.user_group_id && String(item.user_group_id) !== "-" && String(item.user_group_id) !== "null") {
        return String(item.user_group_id);
      }
      if (item.user_id && String(item.user_id) !== "-" && String(item.user_id) !== "null") {
        return String(item.user_id);
      }
      return String(item.emp_id ?? item.user_group_id ?? item.user_id ?? Math.random());
    }, []);


    const fetchUserGroups = useCallback(
      (searchKey) => {
        if (!searchKey || searchKey.trim() === "") {
          setSearchOptions([]);
          return;
        }

        if (!clientBranchNum) {
          console.warn("fetchUserGroups: clientBranchNum not available yet.");
          setSearchOptions([]);
          return;
        }

        const params = new URLSearchParams();
        params.append("client_branch_id", clientBranchNum);
        params.append("search_key", searchKey);
        params.append("identifier", "2");

        fetch(
          `${EndPoints.GET_USER_AND_GROUPS_SEARCH_KEY}?${params.toString()}`,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        )
          .then((res) => res.json())
          .then((json) => {
            const data = json?.data || [];
            const filtered = data.filter((item) => {
              const identifier = item.identifier ?? 2;
              return identifier === 2;
            });

            const mapped = filtered.map((item) => {
            const id = canonicalIdFor(item);
            const userName = item.user_name && String(item.user_name) !== "-" ? item.user_name : null;
            const employeeName = item.employee_name && String(item.employee_name) !== "-" ? item.employee_name : null;
            const displayName = userName ? `${userName}/${employeeName || 'N/A'}` : (userName || "-");
              return {
                id,
                label: displayName,
              };
            });

            setSearchOptions((prev = []) => {
              const map = new Map();
              mapped.forEach((n) => map.set(String(n.id), n));
              prev.forEach((p) => {
                if (!map.has(String(p.id))) map.set(String(p.id), p);
              });
              return Array.from(map.values());
            });
          })
          .catch((err) => console.error("Error fetching user groups:", err));
      },
      [clientBranchNum, accessToken, canonicalIdFor]
    );

    // ✅ UPDATED: Save to localStorage on toggle
    // const handleToggleChange = useCallback((value) => {
    //   setIsEnabled(value);

    //   setFormData((prev) => {
    //     if (!activeCommModeId || !activeCategory) return prev;

    //     const updated = {
    //       ...prev,
    //       [activeCommModeId]: {
    //         ...prev[activeCommModeId],
    //         [activeCategory]: {
    //           ...prev[activeCommModeId]?.[activeCategory],
    //           enabled: value ? 1 : 0,
    //         },
    //       },
    //     };
    //     saveToStorage(updated);

    //     if (onFormDataChange) {
    //       onFormDataChange(eventConfig.screen_event_id, updated);
    //     }

    //     return updated;
    //   });
    // }, [activeCommModeId, activeCategory, onFormDataChange, eventConfig.screen_event_id, saveToStorage]);


    const handleToggleChange = useCallback((value) => {
      setIsEnabled(value);

      setFormData((prev) => {
        if (!activeCommModeId || !activeCategory) return prev;

        const updated = {
          ...prev,
          [activeCommModeId]: {
            ...prev[activeCommModeId],
            [activeCategory]: {
              ...prev[activeCommModeId]?.[activeCategory],
              enabled: value ? 1 : 0,
            },
          },
        };
        saveToStorage(updated);

        // ✅ Only call onFormDataChange if not initializing
        if (onFormDataChange && !isInitializing.current) {
          onFormDataChange(eventConfig.screen_event_id, updated);
        }

        return updated;
      });
    }, [activeCommModeId, activeCategory, onFormDataChange, eventConfig.screen_event_id, saveToStorage]);

    // ✅ UPDATED: Save to localStorage on form change
    // const handleFormChange = useCallback(
    //   (field, value) => {
    //     if (!isEnabled) return;

    //     if (field === "body") {
    //       const plainText = value.replace(/<[^>]+>/g, "");
    //       if (plainText.length > 1000) {
    //         const trimmed = plainText.slice(0, 1000);
    //         value = trimmed;
    //       }
    //     }

    //     setFormData((prev) => {
    //       const updated = {
    //         ...prev,
    //         [activeCommModeId]: {
    //           ...prev[activeCommModeId],
    //           [activeCategory]: {
    //             ...prev[activeCommModeId]?.[activeCategory],
    //             [field]: value,
    //           },
    //         },
    //       };
    //       saveToStorage(updated);

    //       if (onFormDataChange) {
    //         onFormDataChange(eventConfig.screen_event_id, updated);
    //       }

    //       return updated;
    //     });
    //   },
    //   [activeCommModeId, activeCategory, isEnabled, onFormDataChange, eventConfig.screen_event_id, saveToStorage]
    // );
    const handleFormChange = useCallback(
      (field, value) => {
        if (!isEnabled) return;

        if (field === "body") {
          const plainText = value.replace(/<[^>]+>/g, "");
          if (plainText.length > 1000) {
            const trimmed = plainText.slice(0, 1000);
            value = trimmed;
          }
        }

        setFormData((prev) => {
          const updated = {
            ...prev,
            [activeCommModeId]: {
              ...prev[activeCommModeId],
              [activeCategory]: {
                ...prev[activeCommModeId]?.[activeCategory],
                [field]: value,
              },
            },
          };
          saveToStorage(updated);

          // ✅ Only call onFormDataChange if not initializing
          if (onFormDataChange && !isInitializing.current) {
            onFormDataChange(eventConfig.screen_event_id, updated);
          }

          return updated;
        });
      },
      [activeCommModeId, activeCategory, isEnabled, onFormDataChange, eventConfig.screen_event_id, saveToStorage]
    );


  const placeholders = useMemo(() => {
      return eventConfig.placeholders
        ? eventConfig.placeholders.split(", ").map((p) => p.trim()).filter((p) => p)
        : [];
    }, [eventConfig.placeholders]);

    const sortedCommModes = useMemo(() => {
      if (!eventConfig.comm_modes) return [];
      const categoryOrder = { Email: 0, Messaging: 1, PUSH: 2 };
      const uniqueModes = Array.from(
        new Map(eventConfig.comm_modes.map((mode) => [mode.comm_mode_id, mode])).values()
      );
      return uniqueModes.sort(
        (a, b) => (categoryOrder[a.comm_mode_category] || 999) - (categoryOrder[b.comm_mode_category] || 999)
      );
    }, [eventConfig.comm_modes]);

    const currentCommMode = useMemo(() => {
      return sortedCommModes.find((mode) => mode.comm_mode_id === activeCommModeId);
    }, [sortedCommModes, activeCommModeId]);

    const currentCategoryData = useMemo(() => {
      if (!currentCommMode) return null;
      return currentCommMode[activeCategory];
    }, [currentCommMode, activeCategory]);

    useEffect(() => {
      if (!activeCommModeId || !activeCategory) return;
      const categoryData = formData[activeCommModeId]?.[activeCategory];
      if (categoryData && categoryData.enabled !== undefined && categoryData.enabled !== null) {
        setIsEnabled(categoryData.enabled === 1 || categoryData.enabled === true);
      } else if (currentCategoryData && currentCategoryData.enabled !== undefined && currentCategoryData.enabled !== null) {
        setIsEnabled(currentCategoryData.enabled === 1 || currentCategoryData.enabled === true);
      }
    }, [activeCommModeId, activeCategory, formData, currentCategoryData]);

    const userGroupOptions = useMemo(() => {
      const map = new Map();
      searchOptions.forEach((item) => map.set(String(item.id), item));
      allSelectedUsersData.forEach((item) => {
        if (!map.has(String(item.id))) map.set(String(item.id), item);
      });
      return Array.from(map.values());
    }, [searchOptions, allSelectedUsersData]);


    // useEffect(() => {
    //   if (!activeCommModeId || activeCategory !== "user_group") return;

    //   const userGroupId = formData[activeCommModeId]?.user_group?.user_group_id;

    //   if (userGroupId && String(userGroupId) !== "null" && String(userGroupId) !== "-") {
    //     setSelectedUserGroup(String(userGroupId));
    //     const existsInOptions = userGroupOptions.some(
    //       opt => String(opt.id) === String(userGroupId)
    //     );

    //     if (!existsInOptions && clientBranchNum) {
    //       const params = new URLSearchParams();
    //       params.append("client_branch_id", clientBranchNum);
    //       params.append("search_key", ""); 

    //       fetch(
    //         `${EndPoints.GET_USER_AND_GROUPS_SEARCH_KEY}?${params.toString()}`,
    //         { headers: { Authorization: `Bearer ${accessToken}` } }
    //       )
    //         .then((res) => res.json())
    //         .then((json) => {
    //           const data = json?.data || [];
    //           const foundGroup = data.find(item => {
    //             const id = canonicalIdFor(item);
    //             return String(id) === String(userGroupId);
    //           });

    //           if (foundGroup) {
    //             const id = canonicalIdFor(foundGroup);

    //              const userName = foundGroup.user_name && String(foundGroup.user_name) !== "-" ? foundGroup.user_name : null;
    //             const employeeName = foundGroup.employee_name && String(foundGroup.employee_name) !== "-" ? foundGroup.employee_name : null;
                
    //             const displayName = userName ? `${userName}/${employeeName || 'N/A'}` : (userName || "-");

    //             const mappedOption = {
    //               id,
    //               label: displayName,
    //             };
    //             setAllSelectedUsersData(prev => {
    //               const existingIds = new Set(prev.map(s => String(s.id)));
    //               if (!existingIds.has(String(mappedOption.id))) {
    //                 return [...prev, mappedOption];
    //               }
    //               return prev;
    //             });
    //           }
    //         })
    //         .catch((err) => console.error("Error fetching user group by ID:", err));
    //     }
    //   } else {
    //     setSelectedUserGroup("");
    //   }
    // }, [activeCommModeId, activeCategory, formData, userGroupOptions, clientBranchNum, accessToken, canonicalIdFor]);

    useEffect(() => {
      if (!activeCommModeId || activeCategory !== "user_group") return;

      const userGroupId = formData[activeCommModeId]?.user_group?.user_group_id;

      // ✅ Handle null/empty explicitly
      if (!userGroupId || 
          userGroupId === null || 
          userGroupId === "null" || 
          userGroupId === "-" || 
          userGroupId === "") {
        setSelectedUserGroup("");
        return; // Exit early, don't fetch
      }

      setSelectedUserGroup(String(userGroupId));
      
      const existsInOptions = userGroupOptions.some(
        opt => String(opt.id) === String(userGroupId)
      );

      if (!existsInOptions && clientBranchNum) {
        const params = new URLSearchParams();
        params.append("client_branch_id", clientBranchNum);
        params.append("search_key", ""); 
        params.append("identifier", "2");

        fetch(
          `${EndPoints.GET_USER_AND_GROUPS_SEARCH_KEY}?${params.toString()}`,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        )
          .then((res) => res.json())
          .then((json) => {
            const data = json?.data || [];
            const foundGroup = data.find(item => {
              const id = canonicalIdFor(item);
              return String(id) === String(userGroupId);
            });

            if (foundGroup) {
              const id = canonicalIdFor(foundGroup);
              const userName = foundGroup.user_name && String(foundGroup.user_name) !== "-" ? foundGroup.user_name : null;
              const employeeName = foundGroup.employee_name && String(foundGroup.employee_name) !== "-" ? foundGroup.employee_name : null;
              const displayName = userName ? `${userName}/${employeeName || 'N/A'}` : (userName || "-");

              const mappedOption = {
                id,
                label: displayName,
              };
              setAllSelectedUsersData(prev => {
                const existingIds = new Set(prev.map(s => String(s.id)));
                if (!existingIds.has(String(mappedOption.id))) {
                  return [...prev, mappedOption];
                }
                return prev;
              });
            }
          })
          .catch((err) => console.error("Error fetching user group by ID:", err));
      }
    }, [activeCommModeId, activeCategory, formData, userGroupOptions, clientBranchNum, accessToken, canonicalIdFor]);

    // useEffect(() => {
    //   if (eventConfig.comm_modes && eventConfig.comm_modes.length > 0) {
    //     const uniqueModes = Array.from(
    //       new Map(eventConfig.comm_modes.map((mode) => [mode.comm_mode_id, mode])).values()
    //     );
    //     setActiveCommModeId(uniqueModes[0].comm_mode_id);

    //     const storedData = getStoredData();
        
    //     // Get user_group_id from FIRST mode only (shared across all modes)
    //     const firstModeUserGroupId = storedData[uniqueModes[0].comm_mode_id]?.user_group?.user_group_id
    //       ?? uniqueModes[0].user_group?.user_group_id
    //       ?? null;

    //     // Set shared user group
    //     if (firstModeUserGroupId && String(firstModeUserGroupId) !== "null" && String(firstModeUserGroupId) !== "-") {
    //       setSharedUserGroup(String(firstModeUserGroupId));
    //     }

    //     const initialFormData = {};

    //     uniqueModes.forEach((mode) => {
    //       initialFormData[mode.comm_mode_id] = {
    //         email: {
    //           subject: storedData[mode.comm_mode_id]?.email?.subject ?? mode.email?.notification_subject ?? "",
    //           body: storedData[mode.comm_mode_id]?.email?.body ?? mode.email?.notification_body ?? "",
    //           templateId: storedData[mode.comm_mode_id]?.email?.templateId ?? mode.email?.approved_template_id ?? null,
    //           enabled: storedData[mode.comm_mode_id]?.email?.enabled ?? (mode.email?.enabled ?? 0),
    //         },
    //         student: {
    //           subject: storedData[mode.comm_mode_id]?.student?.subject ?? mode.student?.notification_subject ?? "",
    //           body: storedData[mode.comm_mode_id]?.student?.body ?? mode.student?.notification_body ?? "",
    //           templateId: storedData[mode.comm_mode_id]?.student?.templateId ?? mode.student?.approved_template_id ?? null,
    //           enabled: storedData[mode.comm_mode_id]?.student?.enabled ?? (mode.student?.enabled ?? 0),
    //         },
    //         parent: {
    //           subject: storedData[mode.comm_mode_id]?.parent?.subject ?? mode.parent?.notification_subject ?? "",
    //           body: storedData[mode.comm_mode_id]?.parent?.body ?? mode.parent?.notification_body ?? "",
    //           templateId: storedData[mode.comm_mode_id]?.parent?.templateId ?? mode.parent?.approved_template_id ?? null,
    //           enabled: storedData[mode.comm_mode_id]?.parent?.enabled ?? (mode.parent?.enabled ?? 0),
    //         },
    //         user_group: {
    //           subject: storedData[mode.comm_mode_id]?.user_group?.subject ?? mode.user_group?.notification_subject ?? "",
    //           body: storedData[mode.comm_mode_id]?.user_group?.body ?? mode.user_group?.notification_body ?? "",
    //           templateId: storedData[mode.comm_mode_id]?.user_group?.templateId ?? mode.user_group?.approved_template_id ?? null,
    //           enabled: storedData[mode.comm_mode_id]?.user_group?.enabled ?? (mode.user_group?.enabled ?? 0),
    //           // Use shared user group ID for ALL modes
    //           user_group_id: firstModeUserGroupId,
    //         },
    //       };
    //     });

    //     setFormData(initialFormData);
        
    //     // ✅ DON'T call onFormDataChange during initialization
    //     // This prevents marking the form as "changed" when just loading data
        
    //     // Mark initialization as complete
    //     setTimeout(() => {
    //       isInitializing.current = false;
    //     }, 100);
    //   }
    // }, [eventConfig.comm_modes, eventConfig.screen_event_id, getStoredData]);


  // const handleSharedUserGroupChange = useCallback((newUserGroupId) => {
  //   const normalized = newUserGroupId === null || newUserGroupId === undefined || newUserGroupId === "" 
  //     ? "" 
  //     : String(newUserGroupId);

  //   setSharedUserGroup(normalized);

  //   setFormData((prev) => {
  //     const updated = { ...prev };
      
  //     // ✅ Update user_group_id in ALL communication modes
  //     Object.keys(updated).forEach((modeId) => {
  //       updated[modeId] = {
  //         ...updated[modeId],
  //         user_group: {
  //           ...(updated[modeId]?.user_group || {}),
  //           user_group_id: normalized || null,
  //         },
  //       };
  //     });

  //     saveToStorage(updated);
  //     if (onFormDataChange) {
  //       onFormDataChange(eventConfig.screen_event_id, updated);
  //     }

  //     return updated;
  //   });
  // }, [onFormDataChange, eventConfig.screen_event_id, saveToStorage]);

  // const handleSharedUserGroupChange = useCallback((newUserGroupId) => {
  //   const normalized = newUserGroupId === null || newUserGroupId === undefined || newUserGroupId === "" 
  //     ? "" 
  //     : String(newUserGroupId);

  //   setSharedUserGroup(normalized);

  //   setFormData((prev) => {
  //     const updated = { ...prev };
      
  //     // Update user_group_id in ALL communication modes
  //     Object.keys(updated).forEach((modeId) => {
  //       updated[modeId] = {
  //         ...updated[modeId],
  //         user_group: {
  //           ...(updated[modeId]?.user_group || {}),
  //           user_group_id: normalized || null,
  //         },
  //       };
  //     });

  //     saveToStorage(updated);
      
  //     // ✅ Only call onFormDataChange if not initializing
  //     if (onFormDataChange && !isInitializing.current) {
  //       onFormDataChange(eventConfig.screen_event_id, updated);
  //     }

  //     return updated;
  //   });
  // }, [onFormDataChange, eventConfig.screen_event_id, saveToStorage]);


  useEffect(() => {
    if (eventConfig.comm_modes && eventConfig.comm_modes.length > 0) {
      const uniqueModes = Array.from(
        new Map(eventConfig.comm_modes.map((mode) => [mode.comm_mode_id, mode])).values()
      );
      setActiveCommModeId(uniqueModes[0].comm_mode_id);

      const storedData = getStoredData();
      
      // Get user_group_id from FIRST mode only (shared across all modes)
      const firstModeUserGroupId = storedData[uniqueModes[0].comm_mode_id]?.user_group?.user_group_id
        ?? uniqueModes[0].user_group?.user_group_id
        ?? null;

      // ✅ Only set shared user group if it's a valid value
      if (firstModeUserGroupId && 
          firstModeUserGroupId !== null && 
          String(firstModeUserGroupId) !== "null" && 
          String(firstModeUserGroupId) !== "-" &&
          String(firstModeUserGroupId).trim() !== "") {
        setSharedUserGroup(String(firstModeUserGroupId));
      } else {
        setSharedUserGroup(""); // ✅ Explicitly set to empty when null
      }

      const initialFormData = {};

      uniqueModes.forEach((mode) => {
        initialFormData[mode.comm_mode_id] = {
          email: {
            subject: storedData[mode.comm_mode_id]?.email?.subject ?? mode.email?.notification_subject ?? "",
            body: storedData[mode.comm_mode_id]?.email?.body ?? mode.email?.notification_body ?? "",
            templateId: storedData[mode.comm_mode_id]?.email?.templateId ?? mode.email?.approved_template_id ?? null,
            enabled: storedData[mode.comm_mode_id]?.email?.enabled ?? (mode.email?.enabled ?? 0),
          },
          student: {
            subject: storedData[mode.comm_mode_id]?.student?.subject ?? mode.student?.notification_subject ?? "",
            body: storedData[mode.comm_mode_id]?.student?.body ?? mode.student?.notification_body ?? "",
            templateId: storedData[mode.comm_mode_id]?.student?.templateId ?? mode.student?.approved_template_id ?? null,
            enabled: storedData[mode.comm_mode_id]?.student?.enabled ?? (mode.student?.enabled ?? 0),
          },
          parent: {
            subject: storedData[mode.comm_mode_id]?.parent?.subject ?? mode.parent?.notification_subject ?? "",
            body: storedData[mode.comm_mode_id]?.parent?.body ?? mode.parent?.notification_body ?? "",
            templateId: storedData[mode.comm_mode_id]?.parent?.templateId ?? mode.parent?.approved_template_id ?? null,
            enabled: storedData[mode.comm_mode_id]?.parent?.enabled ?? (mode.parent?.enabled ?? 0),
          },
          user_group: {
            subject: storedData[mode.comm_mode_id]?.user_group?.subject ?? mode.user_group?.notification_subject ?? "",
            body: storedData[mode.comm_mode_id]?.user_group?.body ?? mode.user_group?.notification_body ?? "",
            templateId: storedData[mode.comm_mode_id]?.user_group?.templateId ?? mode.user_group?.approved_template_id ?? null,
            enabled: storedData[mode.comm_mode_id]?.user_group?.enabled ?? (mode.user_group?.enabled ?? 0),
            // ✅ Use shared user group ID, but ensure it's null if invalid
            user_group_id: (firstModeUserGroupId && 
                          firstModeUserGroupId !== "null" && 
                          firstModeUserGroupId !== "-" &&
                          String(firstModeUserGroupId).trim() !== "") 
              ? firstModeUserGroupId 
              : null,
          },
        };
      });

      setFormData(initialFormData);
      
      // Mark initialization as complete
      setTimeout(() => {
        isInitializing.current = false;
      }, 100);
    }
  }, [eventConfig.comm_modes, eventConfig.screen_event_id, getStoredData]);

  const handleSharedUserGroupChange = useCallback((newUserGroupId) => {
  // ✅ Handle explicit clearing - treat empty string, null, undefined as null
    const normalized = (newUserGroupId === null || newUserGroupId === undefined || newUserGroupId === "" || newUserGroupId === "-") ? null : String(newUserGroupId);

      setSharedUserGroup(normalized || "");

      setFormData((prev) => {
        const updated = { ...prev };
        
        // Update user_group_id in ALL communication modes
        Object.keys(updated).forEach((modeId) => {
          updated[modeId] = {
            ...updated[modeId],
            user_group: {
              ...(updated[modeId]?.user_group || {}),
              user_group_id: normalized, // ✅ This will be null when cleared
            },
          };
        });

        saveToStorage(updated);
        
        // Only call onFormDataChange if not initializing
        if (onFormDataChange && !isInitializing.current) {
          onFormDataChange(eventConfig.screen_event_id, updated);
        }

        return updated;
      });
    }, [onFormDataChange, eventConfig.screen_event_id, saveToStorage]);

  useEffect(() => {
      if (searchOptions.length > 0 && selectedUserGroup) {
        const selectedUser = searchOptions.find((opt) => String(opt.id) === String(selectedUserGroup));
        if (selectedUser) {
          setAllSelectedUsersData((prev) => {
            const existingIds = new Set(prev.map((s) => String(s.id)));
            if (!existingIds.has(String(selectedUser.id))) {
              return [...prev, selectedUser];
            }
            return prev;
          });
        }
      }
    }, [selectedUserGroup, searchOptions]);

    const isTemplateApprovalRequired = currentCommMode?.template_approval_reqd === "true";

    const modules = {
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ color: [] }, { background: [] }],
        ["link"],
        ["clean"],
      ],
    };

    const formats = [
      "header",
      "bold",
      "italic",
      "underline",
      "strike",
      "list",
      "bullet",
      "color",
      "background",
      "link",
    ];

    const currentFormData = formData[activeCommModeId]?.[activeCategory] || {
      subject: "",
      body: "",
      templateId: null,
      enabled: 0,
    };

    const currentCommModeData = currentCommMode;
    const isDisabled = !isEnabled;

    const handlePlaceholderClick = useCallback(
      (placeholder) => {
        if (!isEnabled) return;

        const textToInsert = ` ${placeholder} `;
        if (currentCommModeData.comm_mode_category !== "Email") {
          const current = currentFormData.body || "";
          const updated = current + textToInsert;   
          handleFormChange("body", updated);
          return;
        }
        const editor = quillRef.current?.getEditor();
        if (editor) {
          const selection = editor.getSelection();
          const cursorPosition = selection ? selection.index : editor.getLength();
          editor.insertText(cursorPosition, textToInsert);
          editor.formatText(cursorPosition + 1, placeholder.length, {
            background: "#FEF3C7",
            color: "#92400E",
          });
          editor.setSelection(cursorPosition + textToInsert.length);
          editor.focus();
        }
      },
      [isEnabled, handleFormChange, currentFormData.body, currentCommModeData, quillRef]
    );

    const PLACEHOLDER_REGEX = /#\w+?#/g;

    const placeholderMap = useMemo(() => {
      if (!eventConfig.placeholders || !eventConfig.example) return {};
      const keys = eventConfig.placeholders
        .split(',')
        .map(p => p.trim());

      const values = eventConfig.example
        .split(',')
        .map(v => v.trim());
      const map = {};          
      keys.forEach((k, i) => {
        map[k] = values[i] ?? '';
      });

      return map;
    }, [eventConfig.placeholders, eventConfig.example]);


    const previewBody = useMemo(() => {
      let text = currentFormData.body || '';
      Object.entries(placeholderMap).forEach(([ph, value]) => {
        const regex = new RegExp(ph.replace(/[#]/g, '\\$&'), 'g'); 
        text = text.replace(regex, value);
      });
      if (currentCommModeData?.comm_mode_category === "Email") {
        text = text
          .replace(/style="[^"]*"/g, '') 
          .replace(/<span[^>]*>(.*?)<\/span>/g, '$1'); 
      }

      return text;
    }, [currentFormData.body, placeholderMap, currentCommModeData]);

    return (
      <div className="accordion-content">
        <div className="display-notfication-config-student-attendence-container">
          <div className="checkbox-with-enable-event-notf-config">
            <input
              type="checkbox"
              className="delete-question-checkbox-dqc"
              checked={isEnabled}
              onChange={(e) => handleToggleChange(e.target.checked)}
            />
            {eventConfig.screen_event_name || `Event ID: ${eventConfig.screen_event_id}`}
          </div>        
          {currentCommModeData && (
            <div className="notif-config-stu-att-form">
              <div className="grid-container-notif-config-stu-att">
                <div className="item1" style={{marginTop: "20px"}}>
                <div 
                  className="item2"
                  style={{
                    opacity: isDisabled ? 0.6 : 1,
                    pointerEvents: isDisabled ? "none" : "auto",
                    gridColumn: "1/2"
                  }}
                >
                  {activeCategory === "user_group" && (
                    <SingleSelectSearchDropdown
                      label="User Group"
                      width="100%"
                      singleSelect={true}
                      selected={sharedUserGroup}  
                      setSelected={handleSharedUserGroupChange}  
                      options={userGroupOptions}
                      placeholder="Type to search user groups..."
                      onSearchInputChange={fetchUserGroups}
                      isRequired={false}
                      disabled={isDisabled}
                    />
                  )}
                </div>
                  <NotificationChannelTabs
                    activeChannel={activeCommModeId}
                    hasUnsavedChanges={false}
                    accessibleChannels={sortedCommModes.map((mode) => ({
                      id: mode.comm_mode_id,
                      label: mode.comm_mode_name,
                      isAccessible: true,  
                    }))}
                    onChannelChange={(channelId) => {
                      if (!channelId) return;
                      setActiveCommModeId(channelId); 
                    }}
                  />
                </div>
                <div 
                  className="item3" 
                  style={{ 
                    gridColumn: "1 / 2",
                    opacity: isDisabled ? 0.6 : 1,
                    pointerEvents: isDisabled ? "none" : "auto",
                  }}
                >
                  {isTemplateApprovalRequired ? (
                    <FormInputs
                      type="text"
                      label="Approved Template ID"
                      value={currentFormData.templateId || ""}
                      onChange={(e) => handleFormChange("templateId", e.target.value)}
                      disabled={isDisabled}
                      pattern="[A-Za-z0-9\s]*"
                      maxlength={10}
                    />
                  ) : currentCommModeData.comm_mode_category === "Email" ? (
                    <FormInputs
                      type="text"
                      label="Email Subject"
                      value={currentFormData.subject}
                      onChange={(e) => handleFormChange("subject", e.target.value)}
                      required
                      disabled={isDisabled}
                      maxlength={500}
                    />
                  ) : null}
                </div>
                
                {/* Message Body */}
                <div 
                  className="item5" 
                  style={{ 
                    gridColumn: "1 / 3",
                    opacity: isDisabled ? 0.6 : 1,
                    pointerEvents: isDisabled ? "none" : "auto",
                  }}
                >
                  <div className="conf-notif-email">
                    <label className="conf-notif-email__label">
                      {currentCommModeData.comm_mode_category === "Email" ? "Email Body" : "Message Body"}
                    </label>
                    {currentCommModeData.comm_mode_category === "Email" ? (
                      <ReactQuill
                        ref={quillRef}
                        value={currentFormData.body}
                        onChange={(value) => handleFormChange("body", value)}
                        modules={modules}
                        formats={formats}
                        placeholder="Write something..."
                        className="custom-react-quill"
                        readOnly={isDisabled}
                      />
                    ) : (
                      <div className="conf-notif-email__textarea">
                        <HighlightWithinTextarea
                          value={currentFormData.body}
                          onChange={(val) => handleFormChange("body", val)}
                          highlight={{ highlight: PLACEHOLDER_REGEX, className: "placeholder-highlight" }}
                          placeholder="Write something..."
                          readOnly={isDisabled}
                          className="conf-notif-email__textarea"
                          containerClassName="textarea-highlight-wrapper"
                        />
                      </div>
                    )}
                  </div>
                </div>
                
                {/* Preview Section */}
                <div 
                  className="conf-notification-preview-container" 
                  style={{ 
                    gridColumn: "3 / 4", 
                    gridRow: "3 / 4",
                    opacity: isDisabled ? 0.6 : 1,
                  }}
                >
                  <div className="right-item-notification-preview">
                    <span>Preview</span>
                    <div className="conf-notif-preview-box">
                      {!isTemplateApprovalRequired && currentFormData.subject && (
                        <div>
                          <strong>Subject:</strong> {currentFormData.subject}
                        </div>
                      )}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: previewBody
                            ?.replace(/style=".*?"/g, '')
                            ?.replace(/<span.*?<\/span>/g, '') || 'Preview will appear here...',
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Placeholders */}
                {placeholders.length > 0 && (
                  <div 
                    className="item6" 
                    style={{ 
                      gridColumn: "1 / 4",
                      opacity: isDisabled ? 0.6 : 1,
                      pointerEvents: isDisabled ? "none" : "auto",
                    }}
                  >
                    <div className="conf-notif-placeholders">
                      <span className="conf-notif-placeholders__label">Available Placeholders</span>
                      <div className="conf-notif-placeholders__chips">
                        {placeholders.map((ph) => (
                          <button
                            key={ph}
                            type="button"
                            className="conf-notif-chip"
                            onClick={() => handlePlaceholderClick(ph)}
                            disabled={isDisabled}
                          >
                            {ph}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
);

EventNotificationForm.displayName = "EventNotificationForm";

function NotificationConfigurationStudentAttendence({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath,
  setNoTimeSet
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeCategory, setActiveCategory] = useState("parent");
  const [activeSubjectId, setActiveSubjectId] = useState(null);
  const [eventConfigs, setEventConfigs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allFormsData, setAllFormsData] = useState({});

  const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
  const UserName = dataClient?.client_schema_name?.[6]?.[0]?.user_name;
  const accessToken = localStorage.getItem("other");
  const [initialAuditSnapshot, setInitialAuditSnapshot] = useState(null);

  const queryParams = new URLSearchParams(location.search);
  const screenId = queryParams.get("screenId");
  const ScreenName = queryParams.get("screen_name");


  const auditConfig = {
    clientBranchId: clientBranchId,
    screenId: screenId,
    userName: UserName,
  };

  const { saveAuditWithData } = useFieldChangeTracker(
    initialAuditSnapshot || {},
    auditConfig
  );


  const permissions = useMemo(() => {
    if (!dataClient?.client_schema_name) return null;
    const screensArray = dataClient.client_schema_name[2];
    if (!Array.isArray(screensArray)) {
      return null;
    }
    const screenData = screensArray.find(
      screen => screen.ui_path === "/notification_config_dashboard"
    );
    return screenData ? {
      create: screenData.create_perm === 1,
      read: screenData.read_perm === 1,
      edit: screenData.edit_perm === 1,
      delete: screenData.delete_perm === 1,
      print: screenData.print === 1,
      download: screenData.download === 1
    } : null;
  }, [dataClient]);


  const clientBranchNum = useMemo(() => {
    if (clientBranchId) return Number(clientBranchId);
    try {
      const stored = localStorage.getItem("client_branch_id");
      return stored ? Number(stored) : null;
    } catch (e) {
      return null;
    }
  }, [clientBranchId]);

  const fetchNotificationConfig = useCallback(async () => {
    if (!clientBranchId || !screenId) return;
    try {
      setLoading(true);
      const response = await fetch(
        `${EndPoints.NotificationConfigByScreenId}?client_branch_id=${clientBranchId}&screen_id=${screenId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch notification config. Please check the API or authentication details.");
      }

      const result = await response.json();
      const data = result.data || [];
      setEventConfigs(data);

      // 🔹 Build initial audit snapshot only once
      const initialSnapshot = {};
      data.forEach((event) => {
        const eventId = event.screen_event_id;
        event.comm_modes?.forEach((mode) => {
          const modeId = mode.comm_mode_id;

          const addCategory = (categoryKey) => {
            const cat = mode[categoryKey];
            if (!cat) return;
            initialSnapshot[
              `${eventId}:${modeId}:${categoryKey}`
            ] = {
              enabled: cat.enabled ?? 0,
              subject: cat.notification_subject ?? "",
              body: cat.notification_body ?? "",
              templateId: cat.approved_template_id ?? null,
              user_group_id: cat.user_group_id ?? null,
            };
          };

          addCategory("parent");
          addCategory("student");
          addCategory("user_group");
        });
      });
      setInitialAuditSnapshot(initialSnapshot);
    } catch (error) {
      console.error("Error fetching config:", error);
    } finally {
      setLoading(false);
    }
  }, [clientBranchId, screenId, accessToken]);


  useEffect(() => {
    fetchNotificationConfig();
  }, [fetchNotificationConfig]);

  const handleTabChange = useCallback((subjectId, newSubjectId) => {
    if (newSubjectId) {
      setActiveSubjectId(newSubjectId);
    } else {
      setActiveSubjectId(subjectId);
    }
  }, []);

  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  // Clear all localStorage keys for this screen
  const clearLocalFormData = useCallback(() => {
    if (!eventConfigs || !screenId) return;
    eventConfigs.forEach((eventConfig) => {
      const storageKey = `notification_config_${screenId}_${eventConfig.screen_event_id}`;
      try {
        localStorage.removeItem(storageKey);
      } catch (e) {
        console.warn("Failed to clear localStorage:", e);
      }
    });
    // also clear in-memory state
    setAllFormsData({});
    setHasUnsavedChanges(false);
  }, [eventConfigs, screenId]);

  const hasActualChanges = (initialData, currentData, eventConfigs) => {
    for (const event of eventConfigs) {
      const eventId = event.screen_event_id;
      const currentEventData = currentData[eventId] || {};

      for (const commMode of event.comm_modes || []) {
        const modeId = commMode.comm_mode_id;
        const currentModeData = currentEventData[modeId] || {};

        // Check each category
        for (const category of ['email', 'student', 'parent', 'user_group']) {
          const apiCategory = commMode[category] || {};
          const currentCategory = currentModeData[category] || {};

          // Get initial values from API
          const initialEnabled = apiCategory.enabled ?? 0;
          const initialSubject = apiCategory.notification_subject ?? "";
          const initialBody = apiCategory.notification_body ?? "";
          const initialTemplateId = apiCategory.approved_template_id ?? null;
          const initialUserGroupId = category === 'user_group'
            ? (apiCategory.user_group_id ?? null)
            : null;

          // Get current values from form
          const currentEnabled = currentCategory.enabled ?? initialEnabled;
          const currentSubject = currentCategory.subject ?? initialSubject;
          const currentBody = currentCategory.body ?? initialBody;
          const currentTemplateId = currentCategory.templateId ?? initialTemplateId;
          const currentUserGroupId = category === 'user_group'
            ? (currentCategory.user_group_id ?? initialUserGroupId)
            : null;

          // Compare values - check if anything actually changed
          if (
            (currentEnabled ? 1 : 0) !== (initialEnabled ? 1 : 0) ||
            String(currentSubject || "").trim() !== String(initialSubject || "").trim() ||
            String(currentBody || "").trim() !== String(initialBody || "").trim() ||
            String(currentTemplateId || "").trim() !== String(initialTemplateId || "").trim() ||
            (category === 'user_group' &&
              String(currentUserGroupId || "") !== String(initialUserGroupId || ""))
          ) {
            return true;
          }
        }
      }
    }
    return false;
  };

  // Replace the handleFormDataChange function with this:
  const handleFormDataChange = useCallback((eventId, formData) => {
    setAllFormsData((prev) => {
      const updated = {
        ...prev,
        [eventId]: formData,
      };

      // Check if there are actual changes compared to API data
      const actualChanges = hasActualChanges({}, updated, eventConfigs);
      setHasUnsavedChanges(actualChanges);

      return updated;
    });
  }, [eventConfigs]);

  // Update the handleCategoryChange function:
  const handleCategoryChange = useCallback(
    (categoryId) => {
      // Check for actual changes before showing warning
      const actualChanges = hasActualChanges({}, allFormsData, eventConfigs);

      if (!actualChanges) {
        // No actual changes, switch directly
        setActiveCategory(categoryId);
        setActiveSubjectId(null);
        setHasUnsavedChanges(false);
        return;
      }

      // Has actual changes, show warning
      setPendingCategory(categoryId);
      setNoTimeSet(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              You have unsaved changes. Do you want to continue?
            </span>
          </div>
          <div
            className="messagebox-insider2"
            style={{ display: "flex", gap: "10px", marginTop: "10px" }}
          >
            <button
              className="messagebox-cancel-btn-ok"
              onClick={() => {
                clearLocalFormData();
                setHasUnsavedChanges(false);
                setIsMessageBoxVisible(false);
                setActiveCategory(categoryId);
                setActiveSubjectId(null);
                setPendingCategory(null);
              }}
            >
              YES
            </button>
            <button
              className="messagebox-cancel-btn-ok"
              onClick={() => {
                setPendingCategory(null);
                setIsMessageBoxVisible(false);
              }}
            >
              NO
            </button>
          </div>
        </div>
      );
      setActiveImg(WarningIcon);
      setIsMessageBoxVisible(true);
    },
    [
      allFormsData,
      eventConfigs,
      clearLocalFormData,
      setMessageBox,
      setIsMessageBoxVisible,
      setActiveImg,
      setNoTimeSet,
    ]
  );
  
  const [pendingCategory, setPendingCategory] = useState(null);

  const handleSaveConfiguration = useCallback(async () => {
    try {
      const currentSnapshot = {};
      eventConfigs.forEach((eventConfig) => {
        const eventId = eventConfig.screen_event_id;
        const eventFormData = allFormsData[eventId] || {};

        eventConfig.comm_modes?.forEach((commMode) => {
          const modeId = commMode.comm_mode_id;
          const commModeFormData = eventFormData[modeId] || {};

          const buildCategorySnapshot = (categoryName) => {
            const apiCategoryData = commMode[categoryName] || {};
            const formCategoryData = commModeFormData[categoryName] || {};

            const enabled =
              formCategoryData.enabled !== undefined &&
                formCategoryData.enabled !== null
                ? formCategoryData.enabled
                  ? 1
                  : 0
                : apiCategoryData.enabled
                  ? 1
                  : 0;

            const subject =
              formCategoryData.subject !== undefined
                ? formCategoryData.subject
                : apiCategoryData.notification_subject || "";

            const body =
              formCategoryData.body !== undefined
                ? formCategoryData.body
                : apiCategoryData.notification_body || "";

            const templateId =
              formCategoryData.templateId !== undefined
                ? formCategoryData.templateId
                : apiCategoryData.approved_template_id ?? null;

            const user_group_id =
              categoryName === "user_group"
                ? formCategoryData.user_group_id ??
                apiCategoryData.user_group_id ??
                null
                : null;

            currentSnapshot[`${eventId}:${modeId}:${categoryName}`] = {
              enabled,
              subject,
              body,
              templateId,
              user_group_id,
            };
          };

          buildCategorySnapshot("user_group");
          buildCategorySnapshot("student");
          buildCategorySnapshot("parent");
        });
      });

      const eventsPayload = eventConfigs
        .map((eventConfig) => {
          const eventFormData = allFormsData[eventConfig.screen_event_id] || {};

          const commModesPayload = eventConfig.comm_modes
            .map((commMode) => {
              const commModeFormData = eventFormData[commMode.comm_mode_id] || {};

              const hasCategoryData = (categoryName) => {
                const apiCategoryData = commMode[categoryName] || {};
                const formCategoryData = commModeFormData[categoryName] || {};

                return (
                  (formCategoryData.enabled === 1 ||
                    apiCategoryData.enabled === 1) ||
                  (formCategoryData.body &&
                    formCategoryData.body.trim()) ||
                  (formCategoryData.subject &&
                    formCategoryData.subject.trim()) ||
                  (formCategoryData.user_group_id &&
                    categoryName === "user_group") ||
                  (formCategoryData.templateId &&
                    formCategoryData.templateId.trim() &&
                    categoryName !== "user_group")
                );
              };

              const hasAnyData = ["user_group", "student", "parent"].some(
                hasCategoryData
              );
              if (!hasAnyData) return null;

              const commModeData = {
                comm_mode_id: commMode.comm_mode_id,
              };

              const notificationTemplateId =
                commMode.notification_template_id;
              if (
                notificationTemplateId &&
                notificationTemplateId !== null &&
                notificationTemplateId !== 0
              ) {
                commModeData.notification_template_id =
                  parseInt(notificationTemplateId);
              }

              // const buildCategoryData = (categoryName) => {
              //   const apiCategoryData = commMode[categoryName] || {};
              //   const formCategoryData =
              //     commModeFormData[categoryName] || {};

              //   const categoryData = {
              //     enabled:
              //       formCategoryData.enabled !== undefined
              //         ? formCategoryData.enabled
              //           ? 1
              //           : 0
              //         : apiCategoryData.enabled
              //           ? 1
              //           : 0,
              //     notification_body:
              //       formCategoryData.body ||
              //       apiCategoryData.notification_body ||
              //       "",
              //     notification_subject:
              //       formCategoryData.subject ||
              //       apiCategoryData.notification_subject ||
              //       "",
              //   };

              //   const templateId =
              //     formCategoryData.templateId !== undefined
              //       ? formCategoryData.templateId
              //       : apiCategoryData.approved_template_id;
              //   if (templateId && templateId !== "" && templateId !== null) {
              //     categoryData.approved_template_id = String(templateId).trim();
              //   }

              //   if (categoryName === "user_group") {
              //     categoryData.user_group_id =
              //       formCategoryData.user_group_id ||
              //       apiCategoryData.user_group_id ||
              //       null;
              //   }

              //   return categoryData;
              // };

              const buildCategoryData = (categoryName) => {
                const apiCategoryData = commMode[categoryName] || {};
                const formCategoryData = commModeFormData[categoryName] || {};

                const categoryData = {
                  enabled:
                    formCategoryData.enabled !== undefined
                      ? formCategoryData.enabled ? 1 : 0
                      : apiCategoryData.enabled ? 1 : 0,
                  notification_body:
                    formCategoryData.body ||
                    apiCategoryData.notification_body ||
                    "",
                  notification_subject:
                    formCategoryData.subject ||
                    apiCategoryData.notification_subject ||
                    "",
                };

                const templateId =
                  formCategoryData.templateId !== undefined
                    ? formCategoryData.templateId
                    : apiCategoryData.approved_template_id;
                if (templateId && templateId !== "" && templateId !== null) {
                  categoryData.approved_template_id = String(templateId).trim();
                }

                if (categoryName === "user_group") {
                  // ✅ Explicitly handle null/empty user_group_id
                  const userGroupId = formCategoryData.user_group_id !== undefined 
                    ? formCategoryData.user_group_id 
                    : apiCategoryData.user_group_id;
                  
                  // Only set if it's a valid value, otherwise send null
                  categoryData.user_group_id = (userGroupId && 
                                                userGroupId !== "null" && 
                                                userGroupId !== "-" &&
                                                String(userGroupId).trim() !== "") 
                    ? userGroupId 
                    : null;
                }

                return categoryData;
              };

              commModeData.user_group = buildCategoryData("user_group");
              commModeData.student = buildCategoryData("student");
              commModeData.parent = buildCategoryData("parent");

              return commModeData;
            })
            .filter(Boolean);

          if (commModesPayload.length === 0) return null;

          return {
            screen_event_id: eventConfig.screen_event_id,
            comm_modes: commModesPayload,
          };
        })
        .filter(Boolean);

      const payload = {
        screen_id: parseInt(screenId),
        client_branch_id: parseInt(clientBranchId),
        user_name: UserName,
        events: eventsPayload,
      };

      const response = await fetch(
        `${EndPoints.UPDATE_NOTIFICATION_CONFIG_API}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message ||
          "Failed to save notification configuration"
        );
      }

      const result = await response.json();

      // 🔹 4) Audit trail call ONLY on success
      if (initialAuditSnapshot) {
        await saveAuditWithData(initialAuditSnapshot, currentSnapshot);
      }

      // 🔹 5) Clear all localStorage for this screen on success
      eventConfigs.forEach((eventConfig) => {
        const storageKey = `notification_config_${screenId}_${eventConfig.screen_event_id}`;
        try {
          localStorage.removeItem(storageKey);
        } catch (e) {
          console.warn("Failed to clear localStorage:", e);
        }
      });

      if (setMessageBox) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Notification configuration saved successfully.</span>
            </div>
          </div>
        );
        setActiveImg(SuccessImg);
        setIsMessageBoxVisible(true);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      console.error("Error saving config:", error);
      if (setMessageBox) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc error"></div>
              <span>
                {error.message ||
                  "Failed to save notification configuration."}
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        setIsMessageBoxVisible(true);
        setTimeout(() => setIsMessageBoxVisible(false), 2000);
      }
    }
  }, [
    eventConfigs,
    allFormsData,
    screenId,
    clientBranchId,
    UserName,
    accessToken,
    initialAuditSnapshot,
    saveAuditWithData,
    setMessageBox,
    setActiveImg,
    setIsMessageBoxVisible,
  ]);

  const memoizedEventConfigs = useMemo(() => eventConfigs, [eventConfigs]);


  const checkTemplateIdChanges = (eventConfigs, allFormsData) => {
    for (const event of eventConfigs) {
      const eventId = event.screen_event_id;
      const eventFormData = allFormsData[eventId] || {};

      for (const commMode of event.comm_modes) {
        const modeId = commMode.comm_mode_id;
        const modeFormData = eventFormData[modeId] || {};

        for (const category of ['user_group', 'student', 'parent']) {
          const apiConfig = commMode[category] || {};
          const formConfig = modeFormData[category] || {};

          const apiTemplateId = apiConfig.approved_template_id;
          const formTemplateId = formConfig.templateId;

          if (
            formTemplateId &&
            apiTemplateId &&
            String(formTemplateId).trim() !== String(apiTemplateId).trim()
          ) {
            return true;
          }
        }
      }
    }
    return false;
  };

  const checkUserGroupSelection = (eventConfigs, allFormsData) => {
    for (const event of eventConfigs) {
      const eventId = event.screen_event_id;
      const eventFormData = allFormsData[eventId] || {};

      for (const commMode of event.comm_modes) {
        const modeId = commMode.comm_mode_id;
        const modeFormData = eventFormData[modeId] || {};

        const userGroupConfig = modeFormData.user_group || {};
        const apiUserGroupConfig = commMode.user_group || {};

        const userGroupIdForm = userGroupConfig.user_group_id;
        const userGroupIdAPI = apiUserGroupConfig.user_group_id;

        const enabledForm = userGroupConfig.enabled === 1;
        const enabledApi = apiUserGroupConfig.enabled === 1;

        // Check if user group id exists and is enabled either in form or API config
        if (
          ((typeof userGroupIdForm === 'string' && userGroupIdForm.trim() !== '') ||
            (typeof userGroupIdAPI === 'string' && userGroupIdAPI.trim() !== '')) &&
          (enabledForm || enabledApi)
        ) {
          return true;
        }
      }
    }
    return false;
  };

  const showUserGroupWarning = () => {
    setNoTimeSet(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>
            Notifications will be sent to all users in the selected User Group. Do you want to continue?
          </span>
        </div>
        <div className="messagebox-insider2" style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => {
              setIsMessageBoxVisible(false);
              handleSaveConfiguration();
            }}
          >
            OK
          </button>
          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => setIsMessageBoxVisible(false)}
            style={{width: "80px"}}
          >
            CANCEL
          </button>
        </div>
      </div>
    );
    setActiveImg(WarningIcon);
    setIsMessageBoxVisible(true);
  };

  return (
    <div className="create-role-container">
      <div className="create-role-container-ques-paper-del" style={{ zIndex: "5" }}>
        <span className="create-role-heading">Configure Notification - {ScreenName}</span>
        <div className="create-test-section-btns-container-ques-paper-dels">
          <button
            className="create-test-section-btn-ques-paper-del"
            onClick={() => {
              // Check for actual changes before showing warning
              const actualChanges = hasActualChanges({}, allFormsData, eventConfigs);

              if (actualChanges) {
                setNoTimeSet(true);
                setMessageBox(
                  <div className="Container-messageBOX">
                    <div className="messagebox-insider1">
                      <div className="loader-tc"></div>
                      <span>You have unsaved changes. Do you want to discard them and exit?</span>
                    </div>
                    <div
                      className="messagebox-insider2"
                      style={{ display: "flex", gap: "10px", marginTop: "10px" }}
                    >
                      <button
                        className="messagebox-cancel-btn-ok"
                        onClick={() => {
                          setIsMessageBoxVisible(false);
                          clearLocalFormData();
                          navigate("/notification_config_dashboard");
                        }}
                      >
                        YES
                      </button>
                      <button
                        className="messagebox-cancel-btn-ok"
                        onClick={() => setIsMessageBoxVisible(false)}
                      >
                        NO
                      </button>
                    </div>
                  </div>
                );
                setActiveImg(WarningIcon);
                setIsMessageBoxVisible(true);
              } else {
                clearLocalFormData();
                navigate("/notification_config_dashboard");
              }
            }}
          >
            CANCEL
          </button>
          <button
            className="create-test-section-btn-ques-paper-del"
            disabled={!permissions?.edit}
            style={{
              opacity: !permissions?.edit ? 0.5 : 1,
              cursor: !permissions?.edit ? 'not-allowed' : 'pointer'
            }}
            onClick={() => {
              const hasTemplateChanges = checkTemplateIdChanges(eventConfigs, allFormsData);
              const hasUserGroupSelection = checkUserGroupSelection(eventConfigs, allFormsData);

              if (hasTemplateChanges && hasUserGroupSelection) {
                setNoTimeSet(true);
                setMessageBox(
                  <div className="Container-messageBOX">
                    <div className="messagebox-insider1">
                      <div className="loader-tc"></div>
                      <span>
                        Template ID changed from approved version. Requires approval OR Do you want to Save changes?
                      </span>
                    </div>
                    <div className="messagebox-insider2" style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                      <button
                        className="messagebox-cancel-btn-ok"
                        onClick={() => {
                          setIsMessageBoxVisible(false);
                          showUserGroupWarning();
                        }}
                      >
                        YES
                      </button>
                      <button
                        className="messagebox-cancel-btn-ok"
                        onClick={() => {
                          setIsMessageBoxVisible(false);
                        }}
                      >
                        NO
                      </button>
                    </div>
                  </div>
                );
                setActiveImg(WarningIcon);
                setIsMessageBoxVisible(true);
              } else if (hasUserGroupSelection) {
                showUserGroupWarning();
              } else if (hasTemplateChanges) {
                setNoTimeSet(true);
                setMessageBox(
                  <div className="Container-messageBOX">
                    <div className="messagebox-insider1">
                      <div className="loader-tc"></div>
                      <span>
                        Template ID changed from approved version. Requires approval OR Do you want to Save changes?
                      </span>
                    </div>
                    <div className="messagebox-insider2" style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                      <button
                        className="messagebox-cancel-btn-ok"
                        onClick={() => {
                          setIsMessageBoxVisible(false);
                          handleSaveConfiguration();
                        }}
                      >
                        YES
                      </button>
                      <button
                        className="messagebox-cancel-btn-ok"
                        onClick={() => {
                          setIsMessageBoxVisible(false);
                        }}
                      >
                        NO
                      </button>
                    </div>
                  </div>
                );
                setActiveImg(WarningIcon);
                setIsMessageBoxVisible(true);
              } else {
                handleSaveConfiguration();
              }
            }}
          >
            SAVE
          </button>
        </div>
      </div>

      <NotificationTabComponent
        activeSubjectId={activeSubjectId}
        onTabChange={handleTabChange}
        activeCategory={activeCategory}
        onCategoryChange={handleCategoryChange}
      />

      {loading ? (
        <div className="create-role-container">
          <p>Loading...</p>
        </div>
      ) : memoizedEventConfigs.length === 0 ? (
        <div className="create-role-container">
          <p>No notification configuration found.</p>
        </div>
      ) : (
        <div className="events-container">
          {memoizedEventConfigs.map((eventConfig, index) => (
            <EventNotificationForm
              key={eventConfig.screen_event_id}
              eventConfig={eventConfig}
              clientBranchNum={clientBranchNum}
              accessToken={accessToken}
              activeCategory={activeCategory}
              screenId={screenId}
              onFormDataChange={handleFormDataChange}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default NotificationConfigurationStudentAttendence;



















 // useEffect(() => {
    //   if (eventConfig.comm_modes && eventConfig.comm_modes.length > 0) {
    //     const uniqueModes = Array.from(
    //       new Map(eventConfig.comm_modes.map((mode) => [mode.comm_mode_id, mode])).values()
    //     );
    //     setActiveCommModeId(uniqueModes[0].comm_mode_id);

    //     const storedData = getStoredData();
    //     const initialFormData = {};

    //     uniqueModes.forEach((mode) => {
    //       // Get user_group_id from stored data OR API data
    //       const userGroupId = storedData[mode.comm_mode_id]?.user_group?.user_group_id
    //         ?? mode.user_group?.user_group_id
    //         ?? null;

    //       initialFormData[mode.comm_mode_id] = {
    //         email: {
    //           subject: storedData[mode.comm_mode_id]?.email?.subject ?? mode.email?.notification_subject ?? "",
    //           body: storedData[mode.comm_mode_id]?.email?.body ?? mode.email?.notification_body ?? "",
    //           templateId: storedData[mode.comm_mode_id]?.email?.templateId ?? mode.email?.approved_template_id ?? null,
    //           enabled: storedData[mode.comm_mode_id]?.email?.enabled ?? (mode.email?.enabled ?? 0),
    //         },
    //         student: {
    //           subject: storedData[mode.comm_mode_id]?.student?.subject ?? mode.student?.notification_subject ?? "",
    //           body: storedData[mode.comm_mode_id]?.student?.body ?? mode.student?.notification_body ?? "",
    //           templateId: storedData[mode.comm_mode_id]?.student?.templateId ?? mode.student?.approved_template_id ?? null,
    //           enabled: storedData[mode.comm_mode_id]?.student?.enabled ?? (mode.student?.enabled ?? 0),
    //         },
    //         parent: {
    //           subject: storedData[mode.comm_mode_id]?.parent?.subject ?? mode.parent?.notification_subject ?? "",
    //           body: storedData[mode.comm_mode_id]?.parent?.body ?? mode.parent?.notification_body ?? "",
    //           templateId: storedData[mode.comm_mode_id]?.parent?.templateId ?? mode.parent?.approved_template_id ?? null,
    //           enabled: storedData[mode.comm_mode_id]?.parent?.enabled ?? (mode.parent?.enabled ?? 0),
    //         },
    //         user_group: {
    //           subject: storedData[mode.comm_mode_id]?.user_group?.subject ?? mode.user_group?.notification_subject ?? "",
    //           body: storedData[mode.comm_mode_id]?.user_group?.body ?? mode.user_group?.notification_body ?? "",
    //           templateId: storedData[mode.comm_mode_id]?.user_group?.templateId ?? mode.user_group?.approved_template_id ?? null,
    //           enabled: storedData[mode.comm_mode_id]?.user_group?.enabled ?? (mode.user_group?.enabled ?? 0),
    //           user_group_id: userGroupId, // ✅ FIXED: Now properly loads from storage or API
    //         },
    //       };
    //     });

    //     setFormData(initialFormData);
    //     if (onFormDataChange) {
    //       onFormDataChange(eventConfig.screen_event_id, initialFormData);
    //     }
    //   }
    // }, [eventConfig.comm_modes, eventConfig.screen_event_id, onFormDataChange, getStoredData]);


// CHECK CHANGES THE APPROVEL TEMPALTE ID
  // const checkTemplateIdChanges = (eventConfigs, allFormsData) => {
  //   for (const event of eventConfigs) {
  //     const eventId = event.screen_event_id;
  //     const eventFormData = allFormsData[eventId] || {};

  //     for (const commMode of event.comm_modes) {
  //       const modeId = commMode.comm_mode_id;
  //       const modeFormData = eventFormData[modeId] || {};

  //       for (const category of ['user_group', 'student', 'parent']) {
  //         const apiConfig = commMode[category] || {};
  //         const formConfig = modeFormData[category] || {};

  //         const apiTemplateId = apiConfig.approved_template_id;
  //         const formTemplateId = formConfig.templateId;

  //         // Check if form has templateId but differs from approved one
  //         if (formTemplateId && 
  //             apiTemplateId && 
  //             String(formTemplateId).trim() !== String(apiTemplateId).trim()) {
  //           return true;
  //         }
  //       }
  //     }
  //   }
  //   return false;
  // };





// fullData: {
                  //   id,
                  //   group_name: userName || "-",
                  //   user_name: userName || "-",
                  //   employee_name: foundGroup.employee_name && String(foundGroup.employee_name) !== "-"
                  //     ? foundGroup.employee_name
                  //     : "-",
                  //   emp_id: foundGroup.emp_id && String(foundGroup.emp_id) !== "-"
                  //     ? foundGroup.emp_id
                  //     : null,
                  //   user_group_id: foundGroup.user_group_id && String(foundGroup.user_group_id) !== "-"
                  //     ? foundGroup.user_group_id
                  //     : null,
                  //   user_id: foundGroup.user_id && String(foundGroup.user_id) !== "-"
                  //     ? foundGroup.user_id
                  //     : null,
                  //   staff_number: foundGroup.staff_number || "-",
                  //   designation_name: foundGroup.designation_name || "-",
                  //   department_name: foundGroup.department_name || "-",
                  //   branch_name: foundGroup.branch_name || "-",
                  //   status: foundGroup.status || "-",
                  //   user_count: foundGroup.user_count || "-",
                  //   identifier: foundGroup.identifier || 1,
                  // },

   // fullData: {
                //   id,
                //   group_name: userName|| "-",
                //   user_name: userName || "-",
                //   employee_name: item.employee_name && String(item.employee_name) !== "-" ? item.employee_name : "-",
                //   emp_id: item.emp_id && String(item.emp_id) !== "-" ? item.emp_id : null,
                //   user_group_id: item.user_group_id && String(item.user_group_id) !== "-" ? item.user_group_id : null,
                //   user_id: item.user_id && String(item.user_id) !== "-" ? item.user_id : null,
                //   staff_number: item.staff_number || "-",
                //   designation_name: item.designation_name || "-",
                //   department_name: item.department_name || "-",
                //   branch_name: item.branch_name || "-",
                //   status: item.status || "-",
                //   user_count: item.user_count || "-",
                //   identifier: item.identifier || 1,
                // },


 // <SingleSelectSearchDropdown
                    //   label="User Group"
                    //   width="100%"
                    //   singleSelect={true}
                    //   selected={selectedUserGroup}
                    //   setSelected={(val) => {
                    //     const normalized =
                    //       val === null || val === undefined || val === "" ? "" : String(val);

                    //     setSelectedUserGroup(normalized);
                    //     if (!activeCommModeId) return;

                    //     setFormData((prev) => {
                    //       const updated = {
                    //         ...prev,
                    //         [activeCommModeId]: {
                    //           ...prev[activeCommModeId],
                    //           user_group: {
                    //             ...(prev[activeCommModeId]?.user_group || {}),
                    //             user_group_id: normalized || null,
                    //           },
                    //         },
                    //       };

                    //       saveToStorage(updated);
                    //       if (onFormDataChange) {
                    //         onFormDataChange(eventConfig.screen_event_id, updated);
                    //       }

                    //       return updated;
                    //     });
                    //   }}
                    //   options={userGroupOptions}
                    //   placeholder="Type to search user groups..."
                    //   onSearchInputChange={fetchUserGroups}
                    //   isRequired={false}
                    //   disabled={isDisabled}
                    // />